import {Component, Inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {LookupService} from '../../_services/lookup.service';
import {PortalDocumentResponse} from '../../_model/response/PortalDocumentResponse';
import {environment} from '../../../environments/environment';
import {TABLE_LIST} from '../../_utils/constants';
import {ListDocumentRequest} from '../../_model/request/ListDocumentRequest';
import {FormBuilder} from '@angular/forms';
import {StorageService} from '../../_services/storage.service';
import {ToastrService} from 'ngx-toastr';
import {UtilityService} from '../../_helpers/utility.service';
import {AuthenticationService} from '../../_services/authentication.service';
import {AbsenceService} from '../../_services/absence.service';
import {Absence} from '../../_model/Absence';

@Component({
  selector: 'app-absencedetail',
  templateUrl: './absencedetail.component.html',
  styleUrls: ['./absencedetail.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class AbsencedetailComponent implements OnInit {

    listDocumentRequest: ListDocumentRequest;
    portalDocumentList: PortalDocumentResponse[] = [];
    fileUploadRootPath: string;

    constructor(private absenceService: AbsenceService,
                private formBuilder: FormBuilder,
                private toastr: ToastrService,
                public dialogRef: MatDialogRef<AbsencedetailComponent>,
                @Inject(MAT_DIALOG_DATA) public data: Absence,
                private authService: AuthenticationService,
                private lookupService: LookupService,
                private utilityService: UtilityService,
                private storageServie: StorageService) {
        this.fileUploadRootPath = environment.fileUploadPath;
    }

    ngOnInit() {
        this.listDocumentRequest =  new ListDocumentRequest(TABLE_LIST.ABSENCE, this.data.id);
        this.storageServie.listDocuments(this.listDocumentRequest).subscribe(documentListResult => {
            this.portalDocumentList = [...documentListResult.responseData.items];
        });
    }

    closeModal() {
        this.dialogRef.close();
    }

}
